import owd from 'owd/owd';

export default class Video extends owd.Component {
	init() {
        this.isReady = false;
        this.lastAction = Promise.resolve();
        this.video = this.$element.get(0);
        this.videoPromise = this.getVideoElement();

        this.loadPromise = new Promise((resolve) => {
            this.getVideoElementPromise()
                .then((video) => {
                    this.video = video;
                    
                    if (this.video.readyState > 0) {
                        this.isReady = true;
                        resolve();
                    } else {
                        const _onCanPlay = () => {
                            this.video.removeEventListener('canplay', _onCanPlay);
                            this.isReady = true;
                            resolve();
                        };
        
                        this.video.addEventListener('canplay', _onCanPlay);
                    }
                });
        });
 
        this.$element.data('videoApi', this);
    }

    ready() {
        return this.loadPromise;
    }

    load() {
        if (!this.isReady) {
            this.video.load();
        }

        return this.loadPromise;
    }

    play() {
        this.load().then(() => {
            this.requestAction('play');
        });
    }

    pause() {
        this.ready().then(() => {
            if (!this.video.paused) {
                this.requestAction('pause');
            }
        });
    }
    
    seek(currentTime) {
        this.ready().then(() => {
            this.video.currentTime = currentTime;
        });
    }
    
    reply() {
        this.ready().then(() => {
            this.video.currentTime = 0;
            return this.load();
        }).then(() => {
            this.requestAction('play');
        });
    }

    supportsFullscreen() {
        const video = this.$iframe ? 
            this.$iframe.contents().find("video")[0] : 
            this.video;

        if (video.requestFullscreen) {
	        return true;
	    } else if (video.mozRequestFullScreen) { /* Firefox */
	        return true;
	    } else if (video.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
	        return true;
	    } else if (video.msRequestFullscreen) { /* IE/Edge */
	        return true;
        }
        
        return false;
    }

    fullScreen() {
        const video = this.$iframe ? 
            this.$iframe.contents().find("video")[0] : 
            this.video;
        
        if (video.requestFullscreen) {
	        video.requestFullscreen();
	    } else if (video.mozRequestFullScreen) { /* Firefox */
	        video.mozRequestFullScreen();
	    } else if (video.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
	        video.webkitRequestFullscreen();
	    } else if (video.msRequestFullscreen) { /* IE/Edge */
	        video.msRequestFullscreen();
	    }
    }

    requestAction(action) {
        if (action == 'play' || action == 'pause') {
            this.requestedAction = action;
            this.lastAction.then(() => {
                if (this.requestedAction == 'play') {
                    console.log('actually calling play');
                    if (this.$iframe) {
                        this.lastAction = this.$iframe.contents().find("video")[0].play();
                    } else {
                        this.lastAction = this.video.play();
                    }
                } else {
                    if (this.$iframe) {
                        this.$iframe.contents().find("video")[0].pause();
                    } else {
                        this.video && this.video.pause();
                    }

                    this.lastAction = new Promise(resolve => setTimeout(resolve));
                }
            });
        }
    }

    getVideoElementPromise() {
        return this.videoPromise;
    }

    getVideoElement() {
        const $video = this.$element;
        const is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        const is_chrome_ios = !!navigator.userAgent.match('CriOS');
        const is_firefox_ios = !!navigator.userAgent.match('FxiOS');
        const is_ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

        let video = $video.get(0);

        return new Promise((resolve, reject) => {
            if (is_safari || is_chrome_ios || is_firefox_ios) {
                let $videoClone = $video.clone();
                let $iframe = $('<iframe allowfullscreen webkitAllowFullScreen allow="fullscreen">');
    
                video = $videoClone.get(0);
          
                $iframe.css({
                    background: '#fff',
                    width: '100%',
                    height: '100%',
                    position : 'absolute',
                    zIndex : '1',
                    'pointerEvents' : 'none'
                });
          
                $video.before($iframe);
    
                $iframe.attr('class', $video.attr('class'));
          
                $iframe.ready(() => {
                    $iframe.contents().find("body").append($videoClone);
            
                    $iframe.contents().find("body").css({
                        padding: 0,
                        margin: 0,
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center'
                    });
            
                    $iframe.contents().find("video").css({
                        objectFit: $video.css('object-fit'),
                        width: '100%',
                        height: '100%'
                    });
            
                    this.on('ended', $iframe.contents().find("video"), () => {
                        $video.trigger('iframe-ended');
                    });
            
                    this.on('should-pause', () => {
                        if ($iframe.contents().find("video")[0] && $iframe.contents().find("video")[0].pause) {
                            $iframe.contents().find("video")[0].pause();
                        }
                    });
    
                    video = $iframe.contents().find("video").get(0);
                    $(video).data('videoApi', this);
    
                    resolve(video);
                });
          
                $iframe.addClass('video-iframe-polyfill');
          
                this.$iframe = $iframe;
            } else {
                resolve(video);
            }
        });

    }

    destroy() {
        super.destroy();

        if (window.getEventListeners !== undefined) {
            for (let eventType in getEventListeners(this.video)) {
                getEventListeners(this.video)[eventType].forEach(function(o) {
                    o.remove();
                });
            }
        }

        if (this.$iframe) {
            this.$iframe.attr('src', 'about:blank');
            this.$iframe.remove();
        }

        this.$element.data('videoApi', null);
    }
}

owd.registerComponent('video', {
	component: Video
});